import {
  faChartKanban,
  faCircleCheck,
  faCircleUser,
  faListUl,
  faSignal,
  faTag,
  faUserPen,
} from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import {
  faAngleDown,
  faAnglesUp,
  faCircleExclamation,
  faEquals,
  faMinus,
} from '@awesome.me/kit-a6e51d954f/icons/classic/solid';

import ColumnView from './components/ColumnView';
import {
  AssigneeList,
  CreatorList,
  PriorityList,
  StatusList,
  TagList,
} from './components/Header/FilterLists';
import ListView from './components/ListView';

export const DIALOG_TITLES = {
  status: {
    create: 'New status',
    update: 'Edit status',
  },
  task: {
    create: 'New task',
    update: 'Edit task',
  },
};

export const ERROR_TITLES = {
  status: {
    create: 'Unable to create a status.',
    delete: 'Unable to delete the status.',
    update: 'Unable to update the status.',
  },
  task: {
    create: 'Unable to create a task.',
    delete: 'Unable to delete the task.',
    update: 'Unable to update the task.',
  },
  workflow: {
    fetch: 'Unable to load workflow.',
  },
};

export const FILTERS = [
  {
    emptyMessage: 'No assignees found.',
    icon: faCircleUser,
    label: 'Assignee',
    listComponent: AssigneeList,
    searchPlaceholder: 'Search assignees...',
    type: 'assignees',
  },
  {
    emptyMessage: 'No creators found.',
    icon: faUserPen,
    label: 'Creator',
    listComponent: CreatorList,
    searchPlaceholder: 'Search creators...',
    type: 'creators',
  },
  {
    emptyMessage: 'No priorities found.',
    icon: faSignal,
    label: 'Priority',
    listComponent: PriorityList,
    searchPlaceholder: 'Search priorities...',
    type: 'priorities',
  },
  {
    emptyMessage: 'No statuses found.',
    icon: faCircleCheck,
    label: 'Status',
    listComponent: StatusList,
    searchPlaceholder: 'Search statuses...',
    type: 'statuses',
  },
  {
    emptyMessage: 'No tags found.',
    icon: faTag,
    label: 'Tag',
    listComponent: TagList,
    searchPlaceholder: 'Search tags...',
    type: 'tags',
  },
];

export const SUCCESS_MESSAGES = {
  status: {
    create: 'Status created.',
    delete: 'Status deleted.',
    update: 'Status updated.',
  },
  task: {
    create: 'Task created.',
    delete: 'Task deleted.',
    update: 'Task updated.',
  },
};

export const TABS_CONFIG = [
  { component: ColumnView, icon: faChartKanban, label: 'Columns', value: 'columns' },
  { component: ListView, icon: faListUl, label: 'List', value: 'list' },
];

export const TASK_PRIORITIES = {
  high: {
    color: 'text-red-600',
    icon: faAnglesUp,
  },
  low: {
    color: 'text-blue-600',
    icon: faAngleDown,
  },
  medium: {
    color: 'text-yellow-600',
    icon: faEquals,
  },
  none: {
    color: 'text-gray-400',
    icon: faMinus,
  },
  urgent: {
    color: 'text-orange-600',
    icon: faCircleExclamation,
  },
};
